//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


	import {page,getContCmp} from '@/api/cmInvo/contInvoice';
	import {Toast} from 'mint-ui';
  	import {guid} from '@/utils/common';

	export default {
		name:'invoListPage',
		data(){
	      return {
	      	// 查询条件
	        listQuery:{
	        	projCodeName:'',
	        	contCodeName:'',
	        	stageName:'',
	        	status:'',
	        	currentPage:1, // 当前页
	        	pageSize:5, // 每页数据
          		filter:'0' // 是否需要用户过滤 1：需要 0：不需要
	        },
	      	refreshing: false,
	      	loading: false,
	      	listData:[],
	      	comSelDialogFlag:false,
	      	// 公司下拉数据
	      	comSelOptions:[],
	      	// 选择的公司数据
	      	selComData:{
	      		comId:'',
	      		comCode:'',
	      		comName:''
	      	},
	      	// 开票类型
	      	invoType:''
	      }
		},
		created(){
			// 加载数据
			this.loadData();
		},
		computed:{
		},
		mounted: function(){
		},
		methods:{
			// 返回
			goback(){
				// 返回工作台
				this.$router.push({ name:'workbench'});
			},
			// 筛选
			filter(){

			},
			// 查找
			searchEvent(event){
				if(event.keyCode == 13){
					this.listQuery.currentPage=1;
					this.loadData();
				}
			},
			// 清空条件
			clearFilter(){
				this.listQuery.projCodeName='';
				this.listQuery.contCodeName='';
				this.listQuery.stageName='';
				this.listQuery.status='';
				// 当前页重置
				this.listQuery.currentPage=1;

				this.loadData();
			},
			// 数据刷新(下拉)
		    refresh () {
		      this.refreshing = true;
		      this.$refs.container.scrollTop = 0;

		      this.listQuery.currentPage= 1;
		      setTimeout(() => {
		        // refreshing=true 的情况下加载
		        this.loadData();
		        this.refreshing = false;
		      }, 600);
		    },
		    // 数据加载(上拉)
		    load () {
		      this.loading = true;
		      setTimeout(() => {
		        this.listQuery.currentPage++;
		        // 加载
		        this.loadData2();
		        this.loading = false;
		      }, 600);
		    },
		    // 加载
		    loadData(){
		        var condition = {'condition':JSON.stringify(this.listQuery)};
		        page(condition).then(response => {
	        		// 刷新情况下
	          		this.listData = response.list;
		        });
		    },
		    // 加载数据
		    loadData2(){
		        var condition = {'condition':JSON.stringify(this.listQuery)};
		        page(condition).then(response => {
	        		// 加载数据情况下
	        		var data = response.list;
	        		for(var i=0;i<data.length;i++){
	        			this.listData.push(data[i]);
	        		}
		        });
		    },
		    // 加载合同的客户公司
		    loadCompany(invoType){
		    	var condition = {'invoType':invoType};
		        getContCmp(condition).then(response => {
		        	this.comSelOptions = response.contCmpData;
		        });
		    },
		    // 进入明细
		    itemClick(id,contTypeCode,comName,status){

		    	// 开票类型处理
		    	var invoType = '0';
		    	if(contTypeCode === 'technical_service' || contTypeCode === 'software_sale'){
		    		invoType = '0';
		    	}else if(contTypeCode === 'human_day_service'){
		    		invoType = '1';
		    	}else if(contTypeCode === 'human_day_total'){
		    		invoType = '2';
		    	}

		    	if(status === '待申请开票' || status === '被驳回'){
		    		// 编辑
			    	if(contTypeCode === 'technical_service' || contTypeCode === 'software_sale'){

	            		this.$router.push({ name:'合同开票详情',params:{flag:'1',mainId:id}});
			    	}else if(contTypeCode === 'human_day_service'){
			    		
	            		this.$router.push({ name:'人天服务合同开票申请',params:{flag:'1',mainId:id,comName:comName,'invoType':'1'}});
			    	}else if(contTypeCode === 'human_day_total'){
			    		
	            		this.$router.push({ name:'人天服务总价合同开票申请',params:{flag:'1',mainId:id,comName:comName,'invoType':'2'}});
			    	}
		    	}else{
		    		// 查看
		    		this.$router.push({ name:'合同开票详情查看',params:{flag:'1',mainId:id,comName:comName,'invoType':invoType}});
		    	}
		    },
		    // 开票申请  1：人天服务开票申请 2：人天服务总价合同开票申请
		    invoApplyClick(type){
		    	// 设置开票类型
		    	this.invoType = type;
		    	
	    		this.comSelDialogFlag = true;
	    		this.loadCompany(type);
		    },
		    // 取消dialog
		    cancleDialog(){
		    	this.comSelDialogFlag = false;
		    },
		    // 确认
		    confirmDialog(){
		    	if(this.selComData.comName === ''){
		    		Toast({
					  message: '请选择公司！',
					  position: 'middle',
					  duration: 1500,
					  className:'info'
					});
		    		return;
		    	}

		    	this.comSelDialogFlag = false;
		    	
		    	// 获取id
          		var id = guid();
          		var name = "";
          		if(this.invoType === '1'){
          			name = "人天服务合同开票申请";
          		}else if(this.invoType === '2'){
          			name = "人天服务总价合同开票申请";
          		}
          		// flag: 1: 编辑、查看 0：创建
		    	this.$router.push({ name:name,params:{flag:'0',mainId:id,comName:this.selComData.comName,invoType:this.invoType}});
		    }
		}
	}



// WEBPACK FOOTER //
// ./src/view/cmInvo/invo/invoList.vue